import type { CompanyValues } from '../../../../../types/companyValues'
import type { ComplianceSettingsFormValues } from '../../../types/complianceSettingsFormValues'

export const getComplianceSettingsDefaultValues = (company?: CompanyValues): ComplianceSettingsFormValues => {
  const legalFormSettings = company?.legalFormSettings
  const customLegalMentions = company?.legalMentions?.custom

  return {
    legalFormSettings: {
      isLegalGuaranteeOfConformity: legalFormSettings?.isLegalGuaranteeOfConformity ?? false,
      isMemberOfAccreditedAssociation: legalFormSettings?.isMemberOfAccreditedAssociation ?? false,
      isVatOnDebitsEnabled: legalFormSettings?.isVatOnDebitsEnabled ?? false,
    },
    legalMentions: {
      custom: {
        earlyPaymentDiscount: customLegalMentions?.earlyPaymentDiscount ?? null,
        latePaymentPenaltyRate: customLegalMentions?.latePaymentPenaltyRate ?? null,
      },
    },
  }
}
